import React from "react";
import { TestiMonials } from "./Containt_home";

const Customer = ()=>{
    return <div>
    <h1>Customer</h1>
     <TestiMonials />;
    </div>
}
export default Customer;